/* Native links remain usable without JavaScript; each section owns its state. */
if (!customElements.get('ge-fit-finder')) {
  customElements.define('ge-fit-finder', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.switcher = this.querySelector('.ge-fit__switch');
      if (!this.switcher) return;
      this.switcher.hidden = false;
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) this.showPart(event.target.value);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const block = [...this.querySelectorAll('[data-fit-block]')].find(
          (item) => item.dataset.fitBlock === event.detail?.blockId
        );
        const panel = block?.closest('[data-part]');
        if (panel) this.showPart(panel.dataset.part);
      }, options);
      this.showPart(this.querySelector('input:checked')?.value || 'bowl');
    }

    showPart(part) {
      if (!['bowl', 'downstem'].includes(part)) return;
      this.querySelectorAll('[data-part]').forEach((panel) => {
        panel.hidden = panel.dataset.part !== part;
      });
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === part;
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
